<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>{{ saveText }} User Account</h3>
    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <div>
    <div>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input formControlName="firstName" matInput>
      </mat-form-field>
      @if (firstName.touched && firstName.errors?.required) {
        <mat-error> First name is required </mat-error>
      }
      @if (firstName.touched && firstName.errors?.maxlength) {
        <mat-error> First name must be no more than 50 characters </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input formControlName="lastName" matInput>
      </mat-form-field>
      @if (lastName.touched && lastName.errors?.required) {
        <mat-error> Last name is required </mat-error>
      }
      @if (lastName.touched && lastName.errors?.maxlength) {
        <mat-error> Last name must be no more than 50 characters </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Job Title</mat-label>
        <input formControlName="jobTitle" matInput>
      </mat-form-field>
      @if (jobTitle.touched && jobTitle.errors?.maxlength) {
        <mat-error> Job title must be no more than 100 characters </mat-error>
      }
      @if (jobTitle.touched && jobTitle.errors?.required) {
        <mat-error> Job title is required </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input formControlName="email" matInput>
      </mat-form-field>
      @if (email.touched && email.errors?.required) {
        <mat-error> Email is required </mat-error>
      }
      @if (email.touched && email.errors?.pattern) {
        <mat-error> Email is not formatted correctly (Email) </mat-error>
      }
      @if (email.touched && email.errors?.maxlength) {
        <mat-error> Email must be no more than 100 characters </mat-error>
      }
      @if (email.touched && email.errors?.notUniqueInContacts) {
        <mat-error> Email is not unique in the list of contacts </mat-error>
      }
      @if (email.touched && email.errors?.notUniqueInUsers) {
        <mat-error> Email is not unique in the list of users </mat-error>
      }
    </div>
    <div>
      <mat-form-field>
        <mat-label>Tier</mat-label>
        <mat-select formControlName="userTier" name="userTier">
          @for (lookup of tierLookupData; track lookup.id) {
            <mat-option [value]="lookup.id">
              {{ lookup.text }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (userTier.touched && userTier.errors?.required) {
        <mat-error> Tier is required </mat-error>
      }
    </div>
    <div>
      <mat-form-field>
        <mat-label>Location</mat-label>
        <mat-select formControlName="addressId" name="addressId">
          @for (lookup of addressIdLookupData; track lookup.id) {
            <mat-option [value]="lookup.id">
              {{ lookup.text }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (addressId.touched && addressId.errors?.required) {
        <mat-error> Location is required </mat-error>
      }
    </div>
    @if (warningMessage) {
      <div class="display-message">
        <warning-box [message]="warningMessage"></warning-box>
      </div>
    }

  </div>
</div>
